import React, { useState } from "react";
import Slider from "rc-slider";
import { ENGINE_SETTINGS, DEFAULT_WRITE_MODE } from "../../../../src/shared/constants";
import { StyledContainer } from "./styles";

interface CreativitySliderProps {
  creativitySliderPosition: number;
  setCreativitySliderPosition: (value: number) => void;
  ariaLabel?: string;
  ariaValueMin?: number;
  ariaValueMax?: number;
  ariaValueNow?: number;
}

export default function CreativitySlider({ creativitySliderPosition, setCreativitySliderPosition, ariaLabel, ariaValueMin, ariaValueMax, ariaValueNow }: CreativitySliderProps) {
  const sliderMax = ENGINE_SETTINGS[DEFAULT_WRITE_MODE.value].length - 1;
  const sliderDefault = Math.floor(sliderMax / 2);
  const [sliderValue, setSliderValue] = useState(creativitySliderPosition >= 0 ? creativitySliderPosition : sliderDefault);

  return (
    <StyledContainer>
      <div>
        <h3>Creativity</h3>
      </div>
      <div className="slider-container">
        <Slider
          dots={true}
          dotStyle={{ borderColor: "transparent", width: "3.64px", height: "3.64px", backgroundColor: "var(--slider-dot)" }}
          activeDotStyle={{ backgroundColor: "var(--slider-dot-active)" }}
          handleStyle={{ width: 20, height: 20, marginTop: -6, borderColor: "transparent", boxShadow: "var(--slider-handle-drop-shadow)", opacity: 1 }}
          value={sliderValue}
          min={0}
          max={sliderMax}
          railStyle={{ backgroundColor: "var(--slider-rail)", height: 7.8 }}
          trackStyle={{ backgroundColor: "var(--slider-track)", height: 7.8 }}
          step={1}
          ariaLabelForHandle={ariaLabel}
          aria-valuemin={ariaValueMin}
          aria-valuemax={ariaValueMax}
          aria-valuenow={ariaValueNow}
          onAfterChange={(value) => {
            // Only set after releasing handle in order to reduce network requests
            setCreativitySliderPosition(value as number);
          }}
          onChange={(value) => {
            // Component requires value to get set as state in order to be controllable via UI
            setSliderValue(value as number);
          }}
        />
      </div>
      <div className="range-labels">
        <label className="min">Least</label>
        <label className="max">Most</label>
      </div>
    </StyledContainer>
  );
}
